/**
 * Contextual SHAKE coach-mark: same-tier pair at jellyfish+ after a drop settle.
 */

import * as C from "../config/constants.js";
import { isBodyMerging } from "../flask/system/merge-motion.js";

export function getShakeHintMinTier() {
  var raw = C.SHAKE_HINT_MIN_TIER != null ? Number(C.SHAKE_HINT_MIN_TIER) : 2;
  return isFinite(raw) && raw >= 0 ? Math.floor(raw) : 2;
}

export function getShakeHintSettleMs() {
  var raw = C.SHAKE_HINT_SETTLE_MS != null ? Number(C.SHAKE_HINT_SETTLE_MS) : 3000;
  return isFinite(raw) && raw >= 0 ? raw : 3000;
}

/**
 * True when the flask has two idle (not-merging) bodies at the same tier,
 * starting at jellyfish (`SHAKE_HINT_MIN_TIER`, default 2). Cell and starfish
 * pairs do not count.
 *
 * @param {{ bodies?: Array<{ tier?: number, body?: { id?: number } }>, activeMergeMotions?: Array }|null} system
 * @param {number} [minTier]
 * @returns {boolean}
 */
export function flaskHasShakeHintPair(system, minTier) {
  var bodies = system && system.bodies;
  if (!bodies || !bodies.length) return false;
  var floor = minTier != null ? Math.floor(Number(minTier)) : getShakeHintMinTier();
  if (!isFinite(floor)) floor = 2;
  var counts = Object.create(null);
  for (var i = 0; i < bodies.length; i++) {
    var meta = bodies[i];
    if (!meta) continue;
    var tier = Math.floor(Number(meta.tier));
    if (!isFinite(tier) || tier < floor) continue;
    var bodyId = meta.body && meta.body.id;
    if (bodyId != null && isBodyMerging(system, bodyId)) continue;
    counts[tier] = (counts[tier] || 0) + 1;
    if (counts[tier] >= 2) return true;
  }
  return false;
}

/**
 * @param {object} state
 * @param {boolean} state.dismissed
 * @param {boolean} state.inShake
 * @param {boolean} state.dropHintActive
 * @param {boolean} state.minimizeMode
 * @param {boolean} state.blocked
 * @param {boolean} state.shakeEnabled
 * @param {boolean} state.hasPair
 * @param {boolean} [state.alreadyVisible]
 * @param {number} state.now
 * @param {number} state.readyAt
 * @returns {boolean}
 */
export function shouldShowShakeHint(state) {
  var s = state || {};
  if (s.dismissed) return false;
  if (!s.inShake) return false;
  if (s.dropHintActive) return false;
  if (s.minimizeMode) return false;
  if (s.blocked) return false;
  if (!s.shakeEnabled) return false;
  if (!s.hasPair) return false;
  if (s.alreadyVisible) return true;
  var now = Number(s.now);
  var readyAt = Number(s.readyAt);
  if (!isFinite(now) || !isFinite(readyAt)) return false;
  return now >= readyAt;
}
